export default "__VITE_ASSET__DNEG8dsT__"